<template>
    <div class="full-screen">

        <a @click="$router.go(-1)" class="close"><span class="close__title">Esc</span></a>

        <div class="add-pharmacy-wrapper">

            <div class="pre-title">{{user === 'add'? 'Добавление' : 'Редактирование'}} сотрудника</div>

            <div class="select-holder">
            <select-material
                    :isMulti="false"
                    :title="`Аптека`"
                    :possibleValues="pharmacies"
                    :allowSearch="false"
                    :selectedValues="pharmacy"
                    @select="pharmacy = $event"
            ></select-material>
            </div>

            <div class="pharmacy-add-title">
                <input type="text" placeholder="Фамилия" class="pharmacy-add-title__input" v-model="lastName">
            </div>
            <div class="pharmacy-add-title">
                <input type="text" placeholder="Имя" class="pharmacy-add-title__input" v-model="firstName">
            </div>
            <div class="pharmacy-add-title">
                <input type="text" placeholder="Почта" class="pharmacy-add-title__input" v-model="email">
            </div>
            <div class="pharmacy-add-title">
                <input type="password" placeholder="Пароль" class="pharmacy-add-title__input" v-model="password">
            </div>




            <div class="" style="text-align: center; margin-top: 20px;">

                <a href="#" @click.prevent="save()" class="button">Сохранить</a>

            </div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';
  import selectMaterial from '../html/SelectMaterial';

  export default {
    name: 'user-add',
    created() {
      this.loadPharmacies();
      this.loadUser();
    },
    methods: {
      loadPharmacies() {
        const that = this;
        axios.get('/api/v2/pharmacies/?is_template=false').then((response) => {
          that.pharmacies = response.data;
        });
      },
      loadUser() {
        if (this.user !== 'add') {
          const self = this;
          axios.get(`/api/v2/users/${self.user}`).then((response) => {
            const user = response.data;
            self.pharmacy = user.pharmacy.id;
            self.lastName = user.lastName;
            self.firstName = user.firstName;
            self.email = user.email;
          });
        }
      },
      save() {
        const data = {
          pharmacy: this.pharmacy,
          lastName: this.lastName,
          firstName: this.firstName,
          email: this.email,
          password: this.password,
        };

        const self = this;

        if (this.user !== 'add') {
          if (data.password === '') {
            delete (data.password);
          }
          axios.patch(`/api/v2/users/${self.user}`, data).then(() => {
            self.returnBack();
          });
        } else {
          axios.post('/api/v2/users/', data).then(() => {
            self.returnBack();
          });
        }
      },
      returnBack() {
        this.$router.push('../');
      },
    },
    data() {
      return {
        pharmacies: [],
        pharmacy: '',
        lastName: '',
        firstName: '',
        email: '',
        password: '',
        user: this.$route.params.user,
      };
    },
    components: { selectMaterial },
  };
</script>

<style scoped>
    .select-holder {
        margin-bottom: 40px;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// UserAdd.vue?85117a00